<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { NConfigProvider, NMessageProvider, NDialogProvider, NSpin, darkTheme } from 'naive-ui'
import AdminLayout from './layouts/AdminLayout.vue'
import { isLocalVideoLabPage } from '@/utils/localVideoLab'
import { useAuthStore } from './stores/auth'


const route = useRoute()
const authStore = useAuthStore()
const loading = ref(true)

const isVideoLab = computed(() => isLocalVideoLabPage(import.meta.env.VITE_VIDEO_LAB, window.location.hostname, route.name))
const isAuthPage = computed(() => route.name === 'login')

onMounted(async () => {
  if (!isVideoLab.value && !authStore.isInitialized) await authStore.initialize()
  loading.value = false
})
</script>

<template>
  <NConfigProvider :theme="darkTheme">
    <NMessageProvider placement="bottom">
      <NDialogProvider>
        <div v-if="loading" class="h-screen flex items-center justify-center bg-gray-900">
          <NSpin size="large" />
        </div>
        <template v-else>
          <AdminLayout v-if="authStore.isAuthenticated && !isAuthPage && !isVideoLab">
            <router-view />
          </AdminLayout>
          <router-view v-else />
        </template>
      </NDialogProvider>
    </NMessageProvider>
  </NConfigProvider>
</template>
